
      var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconsAttention = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  id: "icons_attention_a94e584838fe8e8c__icons_attention_i",
  width: 20,
  height: 25,
  viewBox: "0 0 20 25"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icons_attention_a94e584838fe8e8c__clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "icons_attention_a94e584838fe8e8c__Clip_2",
  d: "M0 0h20v25H0z",
  className: "icons_attention_a94e584838fe8e8c__cls-1"
})), /*#__PURE__*/React.createElement("style", null, ".icons_attention_a94e584838fe8e8c__cls-1{fill:none}.icons_attention_a94e584838fe8e8c__cls-4{fill:#e8048b}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "icons_attention_a94e584838fe8e8c__icons_attention_i-2"
}, /*#__PURE__*/React.createElement("path", {
  id: "icons_attention_a94e584838fe8e8c__Clip_2-2",
  d: "M0 0h20v25H0z",
  className: "icons_attention_a94e584838fe8e8c__cls-1"
}), /*#__PURE__*/React.createElement("g", {
  id: "icons_attention_a94e584838fe8e8c__icons_attention_i-3",
  clipPath: "url(#icons_attention_a94e584838fe8e8c__clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "icons_attention_a94e584838fe8e8c__Fill_1",
  fill: "var(--theme-primary, #810ea9)",
  stroke: "var(--theme-primary, #810ea9)",
  strokeMiterlimit: 10,
  d: "M10 25a.566.566 0 0 1-.318-.1c-3.91-2.63-6.39-4.43-7.848-7.235C.3 14.688 0 10.675 0 4.75a.606.606 0 0 1 .355-.55L9.766.046A.491.491 0 0 1 9.943 0h.072a.484.484 0 0 1 .219.046L19.656 4.2a.594.594 0 0 1 .344.55c0 5.925-.3 9.938-1.834 12.92-1.467 2.822-3.944 4.616-7.848 7.235A.563.563 0 0 1 10 25zm.005-23.763L1.188 5.129c.023 6.387.48 9.637 1.688 11.993 1.3 2.507 3.669 4.225 7.129 6.56 3.465-2.345 5.834-4.068 7.118-6.56 1.22-2.357 1.677-5.607 1.688-11.993l-8.806-3.892z"
}), /*#__PURE__*/React.createElement("path", {
  id: "icons_attention_a94e584838fe8e8c__Path",
  d: "M1.48 0a1.487 1.487 0 0 0 0 2.974A1.487 1.487 0 0 0 1.48 0z",
  className: "icons_attention_a94e584838fe8e8c__cls-4",
  transform: "translate(8.526 15.181)"
}), /*#__PURE__*/React.createElement("path", {
  id: "icons_attention_a94e584838fe8e8c__Path-2",
  d: "M1.48 0A1.485 1.485 0 0 0 0 1.487l.3 5.358a1.184 1.184 0 0 0 1.18 1.192 1.182 1.182 0 0 0 1.167-1.192l.3-5.358A1.483 1.483 0 0 0 1.48 0z",
  className: "icons_attention_a94e584838fe8e8c__cls-4",
  transform: "translate(8.526 6.258)"
})))));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" id=\"icons_attention_i\" width=\"20\" height=\"25\" viewBox=\"0 0 20 25\">\r\n    <defs>\r\n        <clipPath id=\"clip-path\">\r\n            <path id=\"Clip_2\" d=\"M0 0h20v25H0z\" class=\"cls-1\"/>\r\n        </clipPath>\r\n        <style>\r\n            .cls-1{fill:none}.cls-4{fill:#e8048b}\r\n        </style>\r\n    </defs>\r\n    <g id=\"icons_attention_i-2\">\r\n        <path id=\"Clip_2-2\" d=\"M0 0h20v25H0z\" class=\"cls-1\"/>\r\n        <g id=\"icons_attention_i-3\" clip-path=\"url(#clip-path)\">\r\n            <path id=\"Fill_1\" fill=\"var(--theme-primary, #810ea9)\" stroke=\"var(--theme-primary, #810ea9)\" stroke-miterlimit=\"10\" d=\"M10 25a.566.566 0 0 1-.318-.1c-3.91-2.63-6.39-4.43-7.848-7.235C.3 14.688 0 10.675 0 4.75a.606.606 0 0 1 .355-.55L9.766.046A.491.491 0 0 1 9.943 0h.072a.484.484 0 0 1 .219.046L19.656 4.2a.594.594 0 0 1 .344.55c0 5.925-.3 9.938-1.834 12.92-1.467 2.822-3.944 4.616-7.848 7.235A.563.563 0 0 1 10 25zm.005-23.763L1.188 5.129c.023 6.387.48 9.637 1.688 11.993 1.3 2.507 3.669 4.225 7.129 6.56 3.465-2.345 5.834-4.068 7.118-6.56 1.22-2.357 1.677-5.607 1.688-11.993l-8.806-3.892z\"/>\r\n            <path id=\"Path\" d=\"M1.48 0a1.487 1.487 0 0 0 0 2.974A1.487 1.487 0 0 0 1.48 0z\" class=\"cls-4\" transform=\"translate(8.526 15.181)\"/>\r\n            <path id=\"Path-2\" d=\"M1.48 0A1.485 1.485 0 0 0 0 1.487l.3 5.358a1.184 1.184 0 0 0 1.18 1.192 1.182 1.182 0 0 0 1.167-1.192l.3-5.358A1.483 1.483 0 0 0 1.48 0z\" class=\"cls-4\" transform=\"translate(8.526 6.258)\"/>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icons_attention.a94e584838fe8e8c4b391486c187c00b.svg"),
        {
          React: SvgIconsAttention,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      